import { useCallback, useRef } from "react";
import styled from "styled-components";
import { useCombinedScroller } from "../combinedScroller";
import { useScene } from "../contexts/sceneContext";

const Header = styled.div`
  text-align: center;
  padding: 16px;
  position: absolute;
  z-index: 10;
  width: 100%;
  color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  & h3 {
    margin: 0;
    margin-left: 24px;
  }
  & span {
    display: inline-block;
  }
`;

const NavigateButton = styled.button`
  background: transparent;
  border: none;
  font-family: grotesk;
  transition: 0.1s ease-in;
  color: ${({ color }) => color};
  cursor: pointer;
  font-size: 16px;
  padding: 16px;
  &:hover {
    opacity: 0.5;
  }
`;

const DarkModeButton = styled.button`
  position: absolute;
  right: 24px;
  bottom: 24px;
  padding: 0;
  font-family: grotesk;
  background: transparent;
  margin: 0;
  cursor: pointer;
  transition: 0.2s ease-in;
  border-radius: 50%;
  border: 1px solid
    ${({ darkMode }) => (darkMode ? "rgba(255, 255, 255, 0.5)" : "#222")};
  height: 35px;
  width: 35px;
  color: ${({ darkMode }) => (darkMode ? "#fff" : "#111")};
  font-size: 16px;
`;
const ChapterHeader = ({ chapter, color, goToNext }) => {
  const headerRef = useRef();
  const { sceneConfig, setConfig } = useScene();
  const { scrollTo } = useCombinedScroller();

  const onClick = useCallback(() => {
    goToNext();
    scrollTo((prev) => ({
      ...prev,
      target: 0,
    }));
  }, [scrollTo, goToNext]);

  return (
    <Header color={color}>
      <h3 ref={headerRef}>Chapter {chapter.name}</h3>
      <NavigateButton onClick={onClick} color={color}>
        →{" "}
      </NavigateButton>

      <DarkModeButton
        onClick={() =>
          setConfig((prev) => ({ ...prev, darkMode: !prev.darkMode }))
        }
        darkMode={sceneConfig.darkMode}
      >
        {sceneConfig.darkMode ? "日" : "月"}
      </DarkModeButton>
    </Header>
  );
};

export default ChapterHeader;
